import { STATES, DELAY_DURATION } from '../components/ProductCard/const';
import * as ShopifyCart from '@shopify/theme-cart';

import { globalEventBus } from '@pixelcabin/ui-utils/lib/vue';

export default {
  data() {
    return {
      state: STATES.READY
    };
  },
  computed: {
    hasButtonStateProgress() {
      return this.state === STATES.PROGRESS;
    },
    hasButtonStateSuccess() {
      return this.state === STATES.SUCCESS;
    },
    hasButtonStateError() {
      return this.state === STATES.ERROR;
    }
  },
  methods: {
    addToCart(variantId, quantity, properties, notificationTitle) {
      let duration = DELAY_DURATION.LONG;
      this.state = STATES.PROGRESS;

      let options = {
        quantity,
        properties
      };
      ShopifyCart.addItem(variantId, options)
        .then(item => {
          window.SLIDECART_UPDATE();
          this.state = STATES.SUCCESS;

          globalEventBus.emit('notification.toggle', {
            id: variantId,
            title: notificationTitle
          });

          if (__DEV__) {
            console.log(
              `An item with a quantity of ${quantity} was added to your cart:`,
              item
            );
          }
        })
        .catch(error => {
          this.state = STATES.ERROR;
          this.$parent.$emit('addToCartError');
          duration = DELAY_DURATION.LONG;
          console.error(error);
        })
        .finally(() => {
          window.setTimeout(() => {
            this.state = STATES.READY;
          }, duration);
        });
    }
  }
};
